<script lang="ts">
  import { Block } from '@reuters-graphics/graphics-components';

  type Props = {
    type: string;
    source: string;
    text: string;
    timestamps: string;
  };

  let { source, text, timestamps }: Props = $props();
</script>

<Block class="my-0">
  <div class="timeline-container">
    <div class="timeline-line"></div>
    <div class="container">
      <div class="header">
        <div class="source {source.replace(' ', '-').toLowerCase()}">
          {source}
        </div>
        <div class="timestamp">{timestamps}</div>
      </div>
      <div class="title-wrapper">
        <div class="title">
          <div class="text">{text}</div>
        </div>
      </div>
    </div>
  </div>
</Block>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  div {
    @include mixins.font-sans;
  }

  .timeline-container {
    position: relative;
    margin: 80px 0 30px;
  }

  .timeline-line {
    position: absolute;
    left: 50%;
    top: -80px;
    bottom: -30px;
    width: 2px;
    background: linear-gradient(
      to bottom,
      transparent 0%,
      rgb(0, 0, 0) 20%,
      rgb(0, 0, 0) 80%,
      transparent 100%
    );
    transform: translateX(-50%);
    z-index: 0;
  }

  .container {
    position: relative;
    text-align: center;
    z-index: 1;
    background-color: white;
    display: inline-block;
    left: 50%;
    transform: translateX(-50%);
    padding: 4px 15px;
  }

  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    margin-bottom: 0px;
  }

  .title-wrapper {
    display: inline-block;
    padding: 0px 12px;
    border-radius: 4px;
  }

  .title {
    display: flex;
    font-weight: bold;
    gap: 10px;
    align-items: center;
    justify-content: center;
    @include mixins.text-base;
  }

  .source {
    background-color: rgb(252, 202, 0);
    color: #333;
    font-weight: bold;
    padding: 2px 4px;
    border: 1px solid rgb(206, 170, 26);
    border-radius: 3px;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    white-space: nowrap;
    &.video-1 {
      background-color: rgb(252, 202, 0);
      color: #333;
      border: 1px solid rgb(206, 170, 26);
    }
    &.video-2 {
      background-color: #10fffb;
      color: #333;
      border: 1px solid #00a8a5;
    }
    &.video-3 {
      background-color: #ff88ff;
      color: #333;
      border: 1px solid #912691;
    }
    &.video-4 {
      background-color: #bfe22d;
      color: #333;
      border: 1px solid #8daa1c;
    }
  }

  .text {
    color: rgb(34, 34, 34);
    font-weight: 600;
  }

  .timestamp {
    @include mixins.text-xs;
    color: rgb(102, 102, 102);
    font-weight: 500;
    letter-spacing: 0.5px;
    white-space: nowrap;
  }
</style>
